<template>
  <div class="animated fadeIn" id="form-actualite">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"></i> Modifier une actualité</strong>
          </div>
            <b-form-group
              description="Surtitre de l'actualité"
              label="Surtitre"
              label-for="Surtitre"
            >
            	<b-form-input id="Surtitre" type="text" :class="{hasError: errors.surtitre !== ''}" v-model="surtitre"></b-form-input>
              <span class="field-error">{{ errors.surtitre }}</span>
            </b-form-group>

            <b-form-group
              description="Titre de l'actualité"
              label="Titre"
              label-for="Titre"
            >
              <b-form-input id="Titre" type="text" :class="{hasError: errors.titre !== ''}" v-model="titre"></b-form-input>
              <span class="field-error">{{ errors.titre }}</span>
            </b-form-group>

            <b-form-group
              description="Contenu de l'actualité"
              label="Contenu"
              label-for="Contenu"
            >
            	<b-form-textarea style="height:120px" id="Contenu" type="text" :class="{hasError: errors.texte !== ''}" v-model="texte"></b-form-textarea>
              <span class="field-error">{{ errors.texte }}</span>
            </b-form-group>

            <b-form-group label="Type de rente concerné" label-for="basicSelect">
                <b-form-select
                    id="basicSelect"
                    :plain="true"
                    :options="[
                        {text: 'Tous', value: 'Tous'},
                        {text: 'Décès', value: 'Décès'},
                        {text: 'Invalidité', value: 'Invalidité'}
                    ]"
                    v-model="selectedTypeRente">
                </b-form-select>
                <span class="field-error">{{ errors.selectedTypeRente }}</span>
            </b-form-group>
            <b-row>
              <b-col sm="6">
                <b-form-group
                  description="Date de début d'affichage de l'actualité"
                  label="Date de début"
                  label-for="dateFrom"
                >
                  <b-form-input id="dateFrom" type="date" :class="{hasError: errors.date_debut !== ''}" v-model="date_debut"></b-form-input>
                  <span class="field-error">{{ errors.date_debut }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group
                  description="Date de fin d'affichage de l'actualité"
                  label="Date de fin"
                  label-for="dateTo"
                >
                  <b-form-input id="dateTo" type="date" :class="{hasError: errors.date_fin !== ''}" v-model="date_fin"></b-form-input>
                  <span class="field-error">{{ errors.date_fin }}</span>
                </b-form-group>
              </b-col>
            </b-row>
            <div slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"></i> Liste des actualités
              </b-button>
              <b-button type="button" @click="edit" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"></i> Enregistrer
              </b-button>
            </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from "@/utils/auth"
import {en, fr} from 'vuejs-datepicker/dist/locale'

export default {
  data() {
  	return {
  	  surtitre : '',
  	  titre: '',
      texte: '',
      selectedTypeRente: '',
      date_debut: '',
      date_fin: '',
      errors: {
        surtitre: '',
        titre: '',
        texte: '',
        date_debut: '',
        date_fin: '',
        selectedTypeRente: ''
      },
      fr: fr,
      DatePickerFormat: 'dd/MM/yyyy'
      // disabledDates: {
      //   to: new Date(Date.now() - 8640000)
      // }
  	};
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
    this.get()
  },
  methods: {
    get() {
      this.$store.commit('IS_LOADING', true)
      let id = this.$route.params.id;
      let self = this;

      this.$axios
        .get("/espaceBeneficiaire/news/" + id)
        .then(response => {
          this.surtitre = response.data.news.surtitre;
          this.titre = response.data.news.titre;
          this.texte = response.data.news.texte;
          this.selectedTypeRente = response.data.news.type_rente;
          this.date_debut = response.data.news.date_debut;
          this.date_fin = response.data.news.date_fin;
          this.$store.commit('IS_LOADING', false)
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false)
          if(error.response && error.response.status === 404 && self != undefined){
            self.$router.push({ path: '/espace-beneficiaire/actualite' })
            self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'l\'actualité avec l\'id '+ id +' n\'existe pas',showConfirmButton: false, timer: 5000})
          }
        });
    },
    edit() {
      if (this.validateData()) {
        this.$store.commit('IS_LOADING', true)
        let id = this.$route.params.id
        let self = this;
        let dataPost = {};
        dataPost.surtitre = this.surtitre;
        dataPost.titre = this.titre;
        dataPost.texte = this.texte;
        dataPost.type_rente = this.selectedTypeRente;
        dataPost.date_debut = this.date_debut;
        dataPost.date_fin = this.date_fin;
        this.$axios
          .put("/espaceBeneficiaire/news/edit/" + id, dataPost)
          .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title:'Modifications avec succès', text:"L'actualité a bien été modifiée",showConfirmButton: false, timer: 5000})
              this.returnBack()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:'Un probléme est survenue, merci de contacter l\'administration',showConfirmButton: false, timer: 5000})
          });
      }
    },
    returnBack() {
      this.$router.push({ path: '/espace-beneficiaire/actualites' })
    },
    validateData () {
      this.clearErrors();
      let dateFrom = new Date(this.date_debut);
      let dateTo = new Date(this.date_fin);
      let regAlpha = this.$store.getters.getRegAlpha
      let dateDuJour = new Date()

      let valid = true;
      if (this.surtitre === "") {
        this.errors.surtitre = "Le surtitre est obligatoire";
        valid= false;
      } else if (this.surtitre.length > 50) {
        valid = false
        this.errors.surtitre  = 'Veuillez entrer un surtitre moins long'
      }

      if (this.titre === "") {
        this.errors.titre = "Le titre est obligatoire";
        valid= false;
      } else if (this.titre.length > 50) {
        valid = false
        this.errors.titre  = 'Veuillez entrer un titre moins long'
      }

      if (this.texte === "") {
        this.errors.texte = "Le contenu de l'actualité est obligatoire";
        valid= false;
      } 

      if (this.date_debut === null || this.date_debut === "") {
        this.errors.date_debut = "La date de début est obligatoire";
        valid= false;
      }

      if (this.date_fin !== null && this.date_fin !== "") {
        if (dateTo.getTime() < dateFrom.getTime()) {
          this.errors.date_fin = "La date de fin doit être postérieure à la date de début";
          valid= false;
        }
        if (dateTo.getTime() < dateDuJour.getTime()) {
          this.errors.date_fin = "La date de fin doit être postérieure à la date du jour";
          valid= false;
        }
      }
      if (this.selectedTypeRente === null || this.selectedTypeRente === "") {
        this.errors.selectedTypeRente = "Le type de rente auquel s'adresse l'actualité est obligatoire";
        valid= false;
      }
      return valid;
    },
    clearErrors() {
      this.errors.surtitre = "";
      this.errors.titre = "";
      this.errors.texte = "";
    }
  }
};
</script>

<style>
</style>
